import { X } from 'lucide-react';

interface ProductProps {
  product: string;
  onRemove: (id: string) => void;
}

export function Product({ product, onRemove }: ProductProps) {
  return (
    <div className='flex items-center justify-between bg-white p-2 rounded-lg transition-colors cursor-pointer'>
      <div className='flex items-center gap-2 flex-1 min-w-0'>
        <span className='truncate text-sm'>{product}</span>
      </div>
      <button onClick={() => onRemove(product)} className='rounded-full p-1 hover:bg-gray-100 transition-colors'>
        <X className='h-4 w-4 text-gray-500' />
        <span className='sr-only'>Remove Product</span>
      </button>
    </div>
  );
}
